<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'COMPANY_SELECT.COMPANY' | translate }}
    </span>

    <!--    <span *ngIf="parentFormGroup.get(passFormControlName).value">-->
    <!--      <button type="button" class="btn btn-ico btn-link" (click)="edit()">-->
    <!--        <i class="fal fa-pencil"></i>-->
    <!--      </button>-->
    <!--    </span>-->
  </div>

  <ng-select
    (change)="onChange($event)"
    [items]="data"
    bindLabel="abbreviation"
    bindValue="id"
    [loading]="loader"
    [formControlName]="passFormControlName"
    appendTo="body"
    [searchFn]="search"
    class="colored-select"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-label-tmp let-item="item">
      <div class="item">
        {{ item.name }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="item">
        {{ item.name }}
      </div>
    </ng-template>

    <!--    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">-->
    <!--      <div class="ng-option disabled">-->
    <!--        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>-->
    <!--        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">-->
    <!--          <i class="fal fa-plus"></i> {{ 'COMPANY_SELECT.ADD' | translate }}-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </ng-template>-->
  </ng-select>
</div>
